import React, { useState, useEffect } from 'react';
import { Modal, Button, Row, Col, Spinner } from 'react-bootstrap';
import { Box, Breadcrumbs, Divider, IconButton, InputBase, Paper, Typography } from '@mui/material';
import { Formik, Form, Field } from 'formik';
import { Input } from 'reactstrap';
import toastAlert from '../../../js/Base/ToastAlert';
import CloseIcon from '@mui/icons-material/Close';
import CompanyNonOrgMemberTable from './CompanyNonOrgMemberTable';
import {
  getNonCompGroupMemberByGroupNo,
  addCompanyGroupMemberApi,
} from '../../../api/companyApi';
import SearchIcon from '@mui/icons-material/Search';


const AddMemberToOrgModal = ({ isModalOpen, handleClose, selectedGroup, submitEffect }) => {
  const [selectedMemberNos, setSelectedMemberNos] = useState([]);
  const [loading, setLoading] = useState(false);
  const [inputValue, setInputValue] = useState('');
  const [filterGroupMember, setFilterGroupMember] = useState([]);
  const [allMembers, setAllMembers] = useState([]);

  useEffect(() => {
    if (isModalOpen) {
      getNonGroupMembers();
    }
  }, [isModalOpen]);

  useEffect(() => {
    const filtered = allMembers.filter(
      (m) =>
        m.account?.name?.includes(inputValue) ||
        m.account?.email?.includes(inputValue)
    );
    setFilterGroupMember(filtered);
  }, [inputValue, allMembers]);

  const getNonGroupMembers = async () => {
    const companyUuid = localStorage.getItem('company_uuid');
    if (!companyUuid) {
      toastAlert.autoClose(true).showError("查無資料，請聯絡系統管理員");
      return;
    }

    try {
      setLoading(true);
      const response = await getNonCompGroupMemberByGroupNo(companyUuid, selectedGroup.uuid);
      const nonCompGroupMember = response.data.members;
      setAllMembers(nonCompGroupMember);
      setLoading(false);
    } catch (error) {
      if (error.__handled) return;
      toastAlert.autoClose(true).showError("發生錯誤，請稍後再試");
    } finally {
    }
  }

  const col_name = ["姓名", "電子信箱"];
  const data_frame = [
    { keyName: 'account.name', isBadge: false },
    { keyName: 'account.email', isBadge: false },
  ];


  const handleCreateGroupMember = async () => {
    if (!selectedGroup?.uuid || selectedMemberNos.length === 0) {
      toastAlert.autoClose(true).showError('請選擇成員');
      return;
    }
  
    const results = [];
  
    for (let i = 0; i < selectedMemberNos.length; i++) {
      const memberNo = selectedMemberNos[i];
  
      try {
        const res = await addCompanyGroupMemberApi(selectedGroup.uuid, memberNo);
  
        if (res?.data?.success) {
          results.push(true);
        } else {
          results.push(false);
        }
      } catch (error) {
        results.push(false);
      }
    }
  
    if (results.length === selectedMemberNos.length) {
      if (!results.includes(false)) {
        toastAlert.autoClose(true).showInfo('新增成功');
      } else {
        toastAlert.autoClose(true).showError('新增失敗');
      }
  
      getNonGroupMembers();
      handleClose();
      submitEffect();
    }
  };


  return (
    <>
      <Modal
        animation="true"
        style={{ zIndex: 13000 }}
        show={isModalOpen}
        onHide={handleClose}
        size="lg"
        className="CompOrgManagement Modal"
        backdropClassName="custom-backdrop"
      >
        <Modal.Header>
          <Modal.Title className="modal-title">新增組織成員</Modal.Title>
        
          {/* 解決籃框問題，自訂MUI按鈕 */}
          <button
            onClick={handleClose}
            style={{
              background: 'transparent',
              border: 'none',
              cursor: 'pointer',
              padding: 0,
              marginLeft: 'auto'
            }}
          >
            <CloseIcon fontSize="medium" />
          </button>
        </Modal.Header>
        <Modal.Body className="modal-body">
        <Row>
          <Col md="5">
            <Paper variant="outlined" component="form" sx={{ p: '2px 2px', display: 'flex', alignItems: 'left', height: '32px' }}>
              <InputBase
                sx={{ flex: 1, p: '10px' }}
                style={{ fontSize: '12px', boxShadow: 'none' }}
                placeholder="請輸入姓名或帳號"
                inputProps={{ 'aria-label': 'search keyword' }}
                value={inputValue}
                onChange={(e) => setInputValue(e.target.value)}
              />
              <IconButton type="button" sx={{ p: '12px' }} aria-label="search">
                <SearchIcon style={{ color: '#E2E2E2' }} />
              </IconButton>
            </Paper>
          </Col>
        </Row>


          <div className="mt-3">
          {loading ? (
          <div className="d-flex justify-content-center my-3">
            <Spinner animation="border" role="status" />
          </div>
        ) : (
            <CompanyNonOrgMemberTable
              rowData={filterGroupMember}
              colName={col_name}
              dataFrame={data_frame}
              selectedMemberNos={selectedMemberNos}
              setSelectedMemberNos={setSelectedMemberNos}
            />
          )}
          </div>

        </Modal.Body>
        <Modal.Footer className="modal-footer">
          <Button
            className="btn btn-custom"
            onClick={handleCreateGroupMember}
            >
            新增
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default AddMemberToOrgModal;
